export * from './featured-image-wrapper';
